import {createFeatureSelector, createSelector, createSelectorFactory, MemoizedProjection} from '@ngrx/store';
import { State } from './tag-tasks.reducer';
import {AnyFn} from '@ngrx/store/src/selector';

export const getTasksFeature = createFeatureSelector<State>('tagTasks');

export function isEqual(a: any, b: any): boolean {
    return a.totalRows === b.totalRows &&
        a.tasks.every(fromA => b.tasks.includes(fromA));
}

export function customMemoize(t: AnyFn): MemoizedProjection {
    let lastResult: any = null;

    function memoized(): any {
        const result = t.apply(null, arguments);

        if (lastResult == null || !isEqual(result, lastResult)) {
            lastResult = result;
            return result;
        }
        return lastResult;
    }

    function reset() { lastResult = null; }

    return {
        clearResult(): void {
        }, setResult(result: any): void {
        }, memoized, reset};
}

export const getTasks = createSelectorFactory(customMemoize)(
    getTasksFeature,
    (state) => {
        return {
            tasks: state.tasks,
            totalRows: state.totalRows,
            currentLazyLoad: state.currentLazyLoad
        };
    }
);
